module.exports = __webpack_public_path__ + "media/steps/car_bcg-f6922238.png";